const Spans = Object.freeze({
    full: { mobile: 4, tablet: 8, desktop: 12 },
    twelve: { mobile: 4, tablet: 8, desktop: 12 },
    eleven: { mobile: 3, tablet: 7, desktop: 11 },
    ten: { mobile: 3, tablet: 6, desktop: 10 },
    nine: { mobile: 2, tablet: 6, desktop: 9 },
    eight: { mobile: 2, tablet: 4, desktop: 8 },
    seven: { mobile: 2, tablet: 4, desktop: 7 },
    six: { mobile: 2, tablet: 4, desktop: 6 },
    half: { mobile: 2, tablet: 4, desktop: 6 },
    five: { mobile: 2, tablet: 4, desktop: 5 },
    four: { mobile: 2, tablet: 4 },
    three: { mobile: 2, tablet: 2, desktop: 3 },
    two: { mobile: 2, tablet: 2 },
    one: { mobile: 1 },
});
export default Spans;
